import { jsx as s, jsxs as p } from "react/jsx-runtime.js";
import { createContext as L, useContext as I, useState as g, useEffect as C, useRef as x } from "react";
const q = (e) => {
  var a;
  const n = (a = e.pits) == null ? void 0 : a.find((i) => i.mark.includes("-menu")), t = n == null ? void 0 : n.materials.map((i) => i.material), r = t == null ? void 0 : t[0];
  return {
    business: r == null ? void 0 : r.business,
    feedback: r == null ? void 0 : r.feedback
  };
}, B = "_iconBox_1xz4q_1", A = "_iconImg_1xz4q_15", T = {
  iconBox: B,
  iconImg: A
};
function E(e) {
  return /* @__PURE__ */ s("div", { className: T.iconBox, children: /* @__PURE__ */ s("img", { className: T.iconImg, src: e.src, alt: e.alt }) });
}
const y = L({}), O = () => I(y), P = ({ children: e, onCustomerServiceClick: n }) => /* @__PURE__ */ s(y.Provider, { value: { onCustomerServiceClick: n }, children: e });
function b({
  children: e,
  renderTrigger: n,
  position: t = "top center",
  trigger: r = "hover",
  arrow: a = !0,
  tip: i = ""
}) {
  const [c, l] = g(!1), [m, f] = g(null);
  C(() => {
    let _ = !0;
    return l(!0), import("reactjs-popup").then((N) => {
      _ && f(() => N.default);
    }), () => {
      _ = !1;
    };
  }, []);
  const u = () => /* @__PURE__ */ s("div", { className: "gd-suspension-panel_popup_trigger", children: n() });
  return !c || !m ? u() : (
    // @ts-ignore
    /* @__PURE__ */ s(
      m,
      {
        className: `gd-suspension-panel_popup${i} gd-suspension-panel_popup_${t}`,
        trigger: u,
        position: t,
        on: r,
        arrow: a,
        children: /* @__PURE__ */ s("div", { className: "gd-suspension-panel_popup_content", children: e })
      }
    )
  );
}
const $ = (e, n) => {
  const t = new CustomEvent(e, {
    detail: n,
    bubbles: !0,
    composed: !0
  });
  window.dispatchEvent(t);
}, w = (e) => {
  const n = /* @__PURE__ */ new Set();
  return {
    dispatch: (t) => $(e, t),
    addListener: (t) => {
      n.has(t) || (n.add(t), window.addEventListener(e, t));
    },
    removeListener: (t) => {
      n.has(t) && (window.removeEventListener(e, t), n.delete(t));
    }
  };
}, K = "@gdesign/suspension-panel/tracker-click", M = "@gdesign/suspension-panel/tracker-export", V = "@gdesign/suspension-panel/customer-service-click", {
  dispatch: F,
  addListener: de,
  removeListener: _e
} = w(K), {
  dispatch: me,
  addListener: ge,
  removeListener: fe
} = w(M), {
  dispatch: H,
  addListener: ve,
  removeListener: Ce
} = w(V);
function R() {
  const e = x(null), { onCustomerServiceClick: n } = O(), t = () => {
    if (F({
      button_name: "客服"
    }), typeof n == "function") {
      n();
      return;
    }
    H(null);
  };
  return /* @__PURE__ */ s(
    b,
    {
      renderTrigger: () => /* @__PURE__ */ s(
        "div",
        {
          className: "gd-suspension-panel_customer-service",
          ref: e,
          onClick: () => t(),
          children: /* @__PURE__ */ s(
            E,
            {
              src: "https://cdn.dancf.com/assets/2025/framework/svg/icon-kf-b.1.svg",
              alt: "customer-service"
            }
          )
        }
      ),
      position: "left center",
      trigger: "hover",
      arrow: !0,
      tip: "_tip",
      children: /* @__PURE__ */ s("div", { children: "联系客服" })
    }
  );
}
const U = "_menuFeedback__trigger_1uwcl_1", z = "_menuFeedback__content_1uwcl_4", W = "_menuFeedback__content_item_1uwcl_7", j = "_menuFeedback__content_item_img_1uwcl_16", X = "_menuFeedback__social_1uwcl_20", Y = "_menuFeedback__social_img_1uwcl_29", G = "_menuFeedback__social_span_1uwcl_33", d = {
  menuFeedback__trigger: U,
  menuFeedback__content: z,
  menuFeedback__content_item: W,
  menuFeedback__content_item_img: j,
  menuFeedback__social: X,
  menuFeedback__social_img: Y,
  menuFeedback__social_span: G
};
function J(e) {
  const { dataSource: n, qrSocialCodeImg: t } = e, r = (c) => {
    c.type === "link" && (F({
      button_name: c.name
    }), window.open(c.link, "_blank"));
  }, a = (c, l) => /* @__PURE__ */ p(
    "div",
    {
      className: d.menuFeedback__content_item,
      onClick: () => r(c),
      children: [
        c.icon ? /* @__PURE__ */ s(
          "img",
          {
            className: d.menuFeedback__content_item_img,
            src: c.icon,
            alt: c.name
          }
        ) : null,
        /* @__PURE__ */ s("span", { className: d.menuFeedback__content_item_name, children: c.name })
      ]
    },
    l
  ), i = (c, l) => {
    if (t)
      return /* @__PURE__ */ s(
        b,
        {
          trigger: "hover",
          position: "left bottom",
          renderTrigger: () => a(c, l),
          children: /* @__PURE__ */ p("div", { className: d.menuFeedback__social, children: [
            /* @__PURE__ */ s(
              "img",
              {
                className: d.menuFeedback__social_img,
                src: t,
                alt: "qr-social-code"
              }
            ),
            /* @__PURE__ */ s("span", { className: d.menuFeedback__social_span, children: "微信扫码加入" }),
            /* @__PURE__ */ s("span", { className: d.menuFeedback__social_span, children: "会员专属社区" })
          ] })
        },
        l
      );
  };
  return /* @__PURE__ */ s(
    b,
    {
      trigger: "hover",
      position: "left bottom",
      renderTrigger: () => /* @__PURE__ */ s("div", { className: d.menuFeedback__trigger, children: /* @__PURE__ */ s(
        E,
        {
          src: "https://cdn.dancf.com/assets/2025/framework/svg/icon-menu.1.svg",
          alt: "feedback"
        }
      ) }),
      children: /* @__PURE__ */ s("div", { className: d.menuFeedback__content, children: n == null ? void 0 : n.map((c, l) => c.type === "community" ? i(c, l) : a(c, l)) })
    }
  );
}
const Q = "_bsConsultationTrigger_7e6yv_1", Z = "_bsConsultationTrigger_span_7e6yv_19", D = "_bsConsultationContent_7e6yv_26", ee = "_bsConsultationContent_img_7e6yv_29", v = {
  bsConsultationTrigger: Q,
  bsConsultationTrigger_span: Z,
  bsConsultationContent: D,
  bsConsultationContent_img: ee
}, S = (e, n) => Array.isArray(e) ? (e || []).some((t) => S(t, n)) : e instanceof RegExp ? e.test(n) : e === "*" || e.endsWith("*") && n.startsWith(e.slice(0, -1)) ? !0 : e === n;
function ne(e) {
  const { dataSource: n } = e, [t, r] = g(null);
  return C(() => {
    n == null || n.forEach((a) => {
      try {
        const i = new URL(a.pageUrl || "");
        S(i.pathname, window.location.pathname) && r(a);
      } catch {
      }
    });
  }, []), t ? /* @__PURE__ */ s(
    b,
    {
      trigger: "hover",
      position: "left bottom",
      renderTrigger: () => /* @__PURE__ */ s("div", { className: v.bsConsultationTrigger, children: /* @__PURE__ */ s("span", { className: v.bsConsultationTrigger_span, children: "企业咨询" }) }),
      children: /* @__PURE__ */ s("div", { className: v.bsConsultationContent, children: /* @__PURE__ */ s(
        "img",
        {
          className: v.bsConsultationContent_img,
          src: t == null ? void 0 : t.qrcodeUrl,
          alt: "bs-consultation"
        }
      ) })
    }
  ) : null;
}
const te = "_backTop_1vx0z_1", se = {
  backTop: te
};
let o = null, k = null;
const oe = 200, h = () => o === window ? window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0 : (o == null ? void 0 : o.scrollTop) || 0, ce = () => {
  F({
    button_name: "返回顶部"
  });
  const e = h();
  if (e > 0)
    if ("scrollBehavior" in document.documentElement.style)
      o == null || o.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    else {
      const n = -e / 20, t = setInterval(() => {
        h() !== 0 ? o == null || o.scrollBy(0, n) : clearInterval(t);
      }, 10);
    }
};
function re(e) {
  const [n, t] = g(!1), [r, a] = g(0), i = () => {
    k && cancelAnimationFrame(k), k = requestAnimationFrame(() => {
      const f = h() > oe;
      if (f && !n) {
        t(!0);
        let u = 0;
        const _ = () => {
          u >= 1 || (u += 0.1, a(u), requestAnimationFrame(_));
        };
        requestAnimationFrame(_);
      } else if (!f && n) {
        let u = 1;
        const _ = () => {
          if (u <= 0) {
            t(!1);
            return;
          }
          u -= 0.1, a(u), requestAnimationFrame(_);
        };
        requestAnimationFrame(_);
      }
    });
  }, c = () => {
    typeof window < "u" && (o == null || o.removeEventListener("scroll", i));
  }, l = () => {
    typeof window < "u" && (c(), o == null || o.addEventListener("scroll", i, { passive: !0 }), i());
  };
  return C(() => {
    if (!(e != null && e.backTopTargetEl))
      return;
    o = o || window;
    const m = document.getElementById((e == null ? void 0 : e.backTopTargetEl) || "") || document.getElementsByClassName((e == null ? void 0 : e.backTopTargetEl) || "")[0];
    m && (c(), o = m, l());
  }, [e.backTopTargetEl]), C(() => {
    o = o || window, l();
  }, [n]), /* @__PURE__ */ s("div", { className: se.backTop, children: n ? /* @__PURE__ */ s("span", { onClick: ce, style: { opacity: r }, children: /* @__PURE__ */ s(
    E,
    {
      src: "https://cdn.dancf.com/assets/2025/framework/svg/icon-up-arrows.1.svg",
      alt: "back-to-top"
    }
  ) }) : null });
}
const ie = "_suspensionPanel_1wovf_1", ae = {
  suspensionPanel: ie
};
function be(e) {
  const { business: n, feedback: t } = q(e.dataSource);
  return /* @__PURE__ */ s(P, { onCustomerServiceClick: e.onCustomerServiceClick, children: /* @__PURE__ */ p("div", { className: ae.suspensionPanel, children: [
    /* @__PURE__ */ s(R, {}),
    /* @__PURE__ */ s(
      J,
      {
        dataSource: t,
        qrSocialCodeImg: e.dataSource.qrSocialCodeImg
      }
    ),
    /* @__PURE__ */ s(ne, { dataSource: n }),
    /* @__PURE__ */ s(re, { backTopTargetEl: e.backTopTargetEl })
  ] }) });
}
export {
  be as SuspensionPanel,
  Ce as offCustomerServiceClickEventListener,
  _e as offTrackerClickEventListener,
  fe as offTrackerExportEventListener,
  ve as onCustomerServiceClickEventListener,
  de as onTrackerClickEventListener,
  ge as onTrackerExportEventListener
};
